module.exports = __webpack_public_path__ + "static/img/home_bt5.f6989a2b.png";